import { Card, CardBody } from "reactstrap";
import { MoreVertical } from "react-feather";
import CommentsBox from "./CommentsBox";
import LikeContent from "./LikeContent";
import SocialChat from "./SocialChat";
import { dynamicImage } from "../../../../../../utils";
import { UserPostProp } from "../../../../../../types/Applications";
import { Image } from "../../../../../../coreComponents/Image";

const UserPost: React.FC<UserPostProp> = ({ item }) => {
  return (
    <Card>
      <CardBody>
        <div className="new-users-social">
          <div className="d-flex">
            <Image className="rounded-circle m-r-15" src={dynamicImage(`user/1.jpg`)} alt="user121" />
            <div className="flex-grow-1">
              <h3 className="mb-0 f-w-700">ELANA</h3>
              <p>January, 12,2024</p>
            </div>
            <span className="pull-right mt-0">
              <MoreVertical />
            </span>
          </div>
        </div>
        <Image className="img-fluid" alt="timeline" src={dynamicImage(item.image)} />
        <div className="timeline-content">
          <p>{item.text}</p>
          <LikeContent />
          <SocialChat />
          <CommentsBox />
        </div>
      </CardBody>
    </Card>
  );
};

export default UserPost;
